import React, { useEffect, useState } from "react";
import { Grid } from "antd";
import TradeRoom from "./TradeRoom/TradeRoom";
import TradeRoomMobile from "./mobile/TradeRoomMobile"
import './App.css'
import click from '../src/Assets/mixkit-old-camera-shutter-click-1137.wav'


const { useBreakpoint } = Grid;


export default function App() {
  const [onOff, setOnOff] = useState(false)
  const screens = useBreakpoint();
  useEffect(() => {
    const audio = new Audio(click);

    const playSound = () => {
      audio.currentTime = 0;
      audio.play();
    };

    const handleEvent = (e) => {
      if (e.target.closest("#cs") && onOff) {
        playSound();
      }
    };

    document.addEventListener("click", handleEvent);

    return () => {
      document.removeEventListener("click", handleEvent);
    };
  }, [onOff]);



  return (

    <div >
      {screens.lg ?

        <TradeRoom setOnOff={setOnOff} onOff={onOff} />
        :
        <TradeRoomMobile setOnOff={setOnOff} onOff={onOff} />}


    </div>
  );
}
